import habibLogo from "../assets/logos/Habib_logo.png";
import strpLogo from "../assets/logos/Dawlance_logo.png";
import companyLogo from "../assets/logos/AKU_logo.png";
import ASFlogo from "../assets/logos/ASF-logo.png";

function Experience() {
  return (
    <section className="section experience">
      <div className="container-fluid">

        {/* Section Title */}
        <div className="mb-4">
          <h1 className="section-title">Experience & Affiliations</h1>
        </div>

        {/* Marquee Viewport */}
        <div className="experience-viewport">
            <div className="experience-track row g-0">

                {[habibLogo, strpLogo, companyLogo, ASFlogo].map((logo, i) => (
                <div className="col-4 experience-logo" key={`logo-${i}`}>
                    <img src={logo} alt="Experience logo" />
                </div>
                ))}

                {/* duplicate for seamless loop */}
                {[habibLogo, strpLogo, companyLogo, ASFlogo].map((logo, i) => (
                <div className="col-4 experience-logo" key={`logo-dup-${i}`}>
                    <img src={logo} alt="Experience logo duplicate" />
                </div>
                ))}

            </div>
        </div>



      </div>
    </section>
  );
}

export default Experience;
